import mutations from './mutations';
import getters from './getters';

const loadingModule = {
  namespaced: true,
  state() {
    return {
      isLoading: false,
    };
  },

  mutations,
  getters,
};

export default loadingModule;
